import { render, staticRenderFns } from "./RatePlan.vue?vue&type=template&id=0b7e0b59&scoped=true&"
import script from "./RatePlan.vue?vue&type=script&lang=js&"
export * from "./RatePlan.vue?vue&type=script&lang=js&"
import style0 from "./RatePlan.vue?vue&type=style&index=0&id=0b7e0b59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e0b59",
  null
  
)

export default component.exports